/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import cogoToast from "cogo-toast";
import Layout from "../../../layout";
import Card from "../../../components/Card";
import CustomButton from "../../../components/CustomButton";
import { SectionLoader } from "../../../components/PageLoader";
import {
  getJobSeekerPlans,
  getMyJobSeekerSubscription,
  subscribeToJobSeekerPlan,
  cancelJobSeekerSubscription,
} from "../../../redux/actions/jobSeekerSubscriptionActions";
import httpRequest from "../../../ajax";
import { getCurrencySymbol } from "../../../utils/helpers";

/* ─── inline styles ─────────────────────────────────────────── */
const styles = {
  container: {
    fontFamily: "'DM Sans', sans-serif",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "24px",
  },
  headerTitle: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1E2329",
    margin: 0,
  },
  plansGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "20px",
    marginBottom: "24px",
  },
  planCard: {
    background: "#fff",
    border: "2px solid #E8ECF0",
    borderRadius: "12px",
    padding: "24px",
    transition: "all 0.2s ease",
    position: "relative",
    overflow: "hidden",
  },
  planCardHighlighted: {
    border: "2px solid #3A6ED4",
    boxShadow: "0 4px 12px rgba(58, 110, 212, 0.15)",
  },
  planBadge: {
    position: "absolute",
    top: "12px",
    right: "12px",
    background: "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)",
    color: "#fff",
    fontSize: "10px",
    fontWeight: "700",
    padding: "4px 10px",
    borderRadius: "20px",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  },
  planName: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#1E2329",
    margin: "0 0 8px 0",
  },
  planDescription: {
    fontSize: "13px",
    color: "#6B7785",
    margin: "0 0 16px 0",
    lineHeight: "1.5",
  },
  planPrice: {
    fontSize: "28px",
    fontWeight: "700",
    color: "#3A6ED4",
    margin: "0 0 4px 0",
  },
  planPriceSub: {
    fontSize: "12px",
    color: "#8A96A3",
    margin: "0 0 20px 0",
  },
  planFeatures: {
    listStyle: "none",
    padding: 0,
    margin: "0 0 24px 0",
  },
  planFeature: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "13px",
    color: "#4A5568",
    marginBottom: "10px",
  },
  planFeatureIcon: {
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    background: "#D1FAE5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  planFeatureDisabled: {
    opacity: 0.4,
  },
  // Active subscription dashboard
  dashboardCard: {
    background: "#fff",
    border: "1px solid #E8ECF0",
    borderRadius: "12px",
    padding: "24px",
    marginBottom: "20px",
  },
  dashboardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    paddingBottom: "16px",
    borderBottom: "1px solid #E8ECF0",
  },
  dashboardPlanName: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  proBadge: {
    background: "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)",
    color: "#fff",
    fontSize: "10px",
    fontWeight: "700",
    padding: "4px 12px",
    borderRadius: "20px",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  },
  billingInfo: {
    background: "#F7F9FB",
    borderRadius: "8px",
    padding: "16px",
    marginBottom: "20px",
  },
  billingLabel: {
    fontSize: "11px",
    fontWeight: "600",
    color: "#8A96A3",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginBottom: "4px",
  },
  billingValue: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#1E2329",
    margin: 0,
  },
  benefitsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
    marginBottom: "20px",
  },
  benefitCard: {
    background: "#F7F9FB",
    border: "1px solid #E8ECF0",
    borderRadius: "8px",
    padding: "16px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  benefitIcon: {
    width: "32px",
    height: "32px",
    borderRadius: "6px",
    background: "#D1FAE5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  benefitText: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#1E2329",
  },
  creditsDisplay: {
    background: "linear-gradient(135deg, #EEF4FF 0%, #F7F9FF 100%)",
    border: "1px solid #D0DEFF",
    borderRadius: "10px",
    padding: "20px",
    textAlign: "center",
    marginBottom: "20px",
  },
  creditsNumber: {
    fontSize: "36px",
    fontWeight: "700",
    color: "#3A6ED4",
    margin: "0 0 4px 0",
  },
  creditsLabel: {
    fontSize: "12px",
    color: "#6B7785",
    margin: 0,
  },
  actionButtons: {
    display: "flex",
    gap: "12px",
    flexWrap: "wrap",
  },
  cancelModal: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  cancelModalContent: {
    background: "#fff",
    borderRadius: "12px",
    padding: "32px",
    maxWidth: "480px",
    width: "90%",
  },
  cancelModalTitle: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#1E2329",
    margin: "0 0 12px 0",
  },
  cancelModalBody: {
    fontSize: "14px",
    color: "#4A5568",
    lineHeight: "1.6",
    marginBottom: "24px",
  },
  cancelModalActions: {
    display: "flex",
    gap: "12px",
    justifyContent: "flex-end",
  },
};

/* ─── component ─────────────────────────────────────────────── */
const JobSeekerSubscriptions = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.auth);
  const { plans, mySubscription, loading, error } = useSelector(
    (state) => state.jobSeekerSubscription || {},
  );

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showFundWalletModal, setShowFundWalletModal] = useState(false);
  const [subscribing, setSubscribing] = useState(false);
  const [cancelling, setCancelling] = useState(false);

  useEffect(() => {
    let mounted = true;
    window.scrollTo({ top: 0, behavior: "smooth" });

    const fetchData = async () => {
      try {
        await Promise.all([
          getJobSeekerPlans(dispatch),
          getMyJobSeekerSubscription(dispatch),
        ]);
      } catch (err) {
        if (mounted) {
          console.error("Failed to load subscription data:", err);
        }
      }
    };

    fetchData();

    return () => {
      mounted = false;
    };
  }, [dispatch]);

  const currencySymbol = getCurrencySymbol(userData?.country);
  const isFreemium =
    !mySubscription ||
    mySubscription?.tier === "freemium" ||
    mySubscription?.status === "expired";
  const currentTier = isFreemium ? "freemium" : mySubscription?.tier;

  const getDisplayPrice = (plan) => {
    if (!plan) return "0";
    if (currencySymbol === "₦") {
      return parseFloat(plan.price_ngn || 0).toLocaleString();
    }
    return parseFloat(plan.price_usd || 0).toFixed(2);
  };

  const isFreePlan = (plan) => {
    if (!plan) return true;
    if (currencySymbol === "₦") {
      return parseFloat(plan.price_ngn || 0) === 0;
    }
    return parseFloat(plan.price_usd || 0) === 0;
  };

  const handleSubscribe = async (planId) => {
    setSubscribing(true);
    try {
      const result = await subscribeToJobSeekerPlan(dispatch, {
        plan_id: planId,
        payment_method: "wallet",
      });

      if (result?.payload?.status) {
        // Refresh subscription data
        await getMyJobSeekerSubscription(dispatch);

        cogoToast.success("Successfully subscribed!");
      } else if (result?.payload?.code === "insufficient_balance") {
        setShowFundWalletModal(true);
      } else {
        cogoToast.error(
          result?.payload?.message || "Subscription failed. Please try again.",
        );
      }
    } catch (err) {
      console.error("Subscription error:", err);
      cogoToast.error("An error occurred. Please try again.");
    } finally {
      setSubscribing(false);
    }
  };

  const handleCancel = async () => {
    setCancelling(true);
    try {
      const result = await cancelJobSeekerSubscription(dispatch);

      if (result?.payload?.status) {
        await getMyJobSeekerSubscription(dispatch);
        setShowCancelModal(false);
        cogoToast.success(
          "Subscription cancelled. You'll retain access until the end of your billing period.",
        );
      } else {
        cogoToast.error(result?.payload?.message || "Cancellation failed.");
      }
    } catch (err) {
      console.error("Cancellation error:", err);
      cogoToast.error("An error occurred. Please try again.");
    } finally {
      setCancelling(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  /* ─── Active Subscription Dashboard (Management View) ─── */
  const renderActiveDashboard = () => {
    const sub = mySubscription;
    const plan = sub?.plan;
    const isProHunter = sub?.tier === "pro_hunter";
    const isSprintPack = sub?.tier === "sprint_pack";

    return (
      <div style={styles.container}>
        {/* Header */}
        <div style={styles.header}>
          <h1 style={styles.headerTitle}>My Subscriptions</h1>
        </div>

        {/* Plan Card */}
        <div style={styles.dashboardCard}>
          <div style={styles.dashboardHeader}>
            <div style={styles.dashboardPlanName}>
              <h2 style={{ margin: 0, fontSize: "20px", fontWeight: "700" }}>
                Plan: {plan?.name || "Freemium"}
              </h2>
              {isProHunter && <span style={styles.proBadge}>Verified Pro</span>}
            </div>
          </div>

          {/* Next Billing Date (Pro Hunter) */}
          {isProHunter && sub?.expiry_date && (
            <div style={styles.billingInfo}>
              <div style={styles.billingLabel}>Next Billing Date</div>
              <p style={styles.billingValue}>
                Your plan renews on {formatDate(sub.expiry_date)} for{" "}
                {currencySymbol}
                {parseFloat(plan?.price_ngn || 0).toLocaleString()}
              </p>
            </div>
          )}

          {/* Cancelled but still active banner */}
          {sub?.cancel_at_period_end && isProHunter && (
            <div
              style={{
                ...styles.billingInfo,
                background: "#FFF3CD",
                border: "1px solid #FFD875",
              }}
            >
              <div style={styles.billingLabel}>Subscription Cancelled</div>
              <p style={styles.billingValue}>
                You'll retain Pro access until {formatDate(sub.expiry_date)}
              </p>
            </div>
          )}

          {/* Credits Display (Sprint Pack) */}
          {isSprintPack && (
            <div style={styles.creditsDisplay}>
              <p style={styles.creditsNumber}>{sub.credits_remaining ?? 0}</p>
              <p style={styles.creditsLabel}>Credits Remaining</p>
            </div>
          )}

          {/* Active Benefits Tracker */}
          <h3
            style={{
              fontSize: "14px",
              fontWeight: "700",
              marginBottom: "16px",
              color: "#1E2329",
            }}
          >
            Active Benefits
          </h3>
          <div style={styles.benefitsGrid}>
            {isProHunter && (
              <>
                <div style={styles.benefitCard}>
                  <div style={styles.benefitIcon}>
                    <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
                      <path
                        d="M20 6L9 17l-5-5"
                        stroke="#059669"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <span style={styles.benefitText}>
                    Unlimited Off-Platform Matches
                  </span>
                </div>
                <div style={styles.benefitCard}>
                  <div style={styles.benefitIcon}>
                    <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
                      <path
                        d="M20 6L9 17l-5-5"
                        stroke="#059669"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <span style={styles.benefitText}>
                    Unlimited Deep Peer Insights
                  </span>
                </div>
                <div style={styles.benefitCard}>
                  <div style={styles.benefitIcon}>
                    <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
                      <path
                        d="M20 6L9 17l-5-5"
                        stroke="#059669"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <span style={styles.benefitText}>
                    Unlimited AI Resume Rewrites
                  </span>
                </div>
              </>
            )}
            {isSprintPack && (
              <>
                <div style={styles.benefitCard}>
                  <div style={styles.benefitIcon}>
                    <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
                      <path
                        d="M20 6L9 17l-5-5"
                        stroke="#059669"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <span style={styles.benefitText}>
                    Credit-Based Off-Platform Matches
                  </span>
                </div>
                <div style={styles.benefitCard}>
                  <div style={styles.benefitIcon}>
                    <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
                      <path
                        d="M20 6L9 17l-5-5"
                        stroke="#059669"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <span style={styles.benefitText}>
                    1 Credit Each Peer Insights
                  </span>
                </div>
              </>
            )}
            <div style={styles.benefitCard}>
              <div style={styles.benefitIcon}>
                <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
                  <path
                    d="M20 6L9 17l-5-5"
                    stroke="#059669"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <span style={styles.benefitText}>
                {plan?.data_retention_days || 7} Days Data Retention
              </span>
            </div>
          </div>

          {/* Action Buttons */}
          {isSprintPack && (
            <div style={styles.actionButtons}>
              <CustomButton
                additionalClass="p-3"
                text={`Buy 10 More Credits — ${currencySymbol}${(() => {
                  const sp = plans?.find((p) => p.tier === "sprint_pack");
                  return sp ? getDisplayPrice(sp) : (currencySymbol === "₦" ? "15,000" : "9.99");
                })()}`}
                backgroundColor="#3A6ED4"
                color="#fff"
                handleClick={() => {
                  const sprintPlan = plans?.find(
                    (p) => p.tier === "sprint_pack",
                  );
                  if (sprintPlan) handleSubscribe(sprintPlan.id);
                }}
                loading={subscribing}
              />
              <CustomButton
                additionalClass="p-3"
                text="Upgrade to Pro Hunter"
                backgroundColor="#fff"
                color="#3A6ED4"
                border="2px solid #3A6ED4"
                handleClick={() => {
                  const proPlan = plans?.find((p) => p.tier === "pro_hunter");
                  if (proPlan) handleSubscribe(proPlan.id);
                }}
                loading={subscribing}
              />
              <CustomButton
                additionalClass="p-3"
                text="Downgrade to Freemium"
                backgroundColor="#fff"
                color="#6B7785"
                border="1px solid #E8ECF0"
                handleClick={() => {
                  const freePlan = plans?.find((p) => p.tier === "freemium");
                  if (freePlan) handleSubscribe(freePlan.id);
                }}
                loading={subscribing}
              />
            </div>
          )}
          {isProHunter && !sub?.cancel_at_period_end && (
            <div style={styles.actionButtons}>
              <CustomButton
                additionalClass="p-3"
                text="Cancel Subscription"
                backgroundColor="#fff"
                color="#DC2626"
                border="1px solid #DC2626"
                handleClick={() => setShowCancelModal(true)}
                loading={cancelling}
              />
              <CustomButton
                additionalClass="p-3"
                text="Downgrade to Sprint Pack"
                backgroundColor="#fff"
                color="#3A6ED4"
                border="2px solid #3A6ED4"
                handleClick={() => {
                  const sprintPlan = plans?.find(
                    (p) => p.tier === "sprint_pack",
                  );
                  if (sprintPlan) handleSubscribe(sprintPlan.id);
                }}
                loading={subscribing}
              />
              <CustomButton
                additionalClass="p-3"
                text="Downgrade to Freemium"
                backgroundColor="#fff"
                color="#6B7785"
                border="1px solid #E8ECF0"
                handleClick={() => {
                  const freePlan = plans?.find((p) => p.tier === "freemium");
                  if (freePlan) handleSubscribe(freePlan.id);
                }}
                loading={subscribing}
              />
            </div>
          )}
          {isProHunter && sub?.cancel_at_period_end && (
            <div style={styles.actionButtons}>
              <CustomButton
                additionalClass="p-3"
                text="Reactivate Pro Hunter"
                backgroundColor="#3A6ED4"
                color="#fff"
                handleClick={() => {
                  const proPlan = plans?.find((p) => p.tier === "pro_hunter");
                  if (proPlan) handleSubscribe(proPlan.id);
                }}
                loading={subscribing}
              />
            </div>
          )}
        </div>
      </div>
    );
  };

  /* ─── Plan Comparison (Sales View) ─────────────────────── */
  const renderPlanComparison = () => {
    const planOrder = ["freemium", "sprint_pack", "pro_hunter"];
    const sortedPlans = plans
      ? [...plans].sort(
          (a, b) => planOrder.indexOf(a.tier) - planOrder.indexOf(b.tier),
        )
      : [];

    return (
      <div style={styles.container}>
        {/* Header */}
        <div style={styles.header}>
          <h1 style={styles.headerTitle}>Choose Your Plan</h1>
        </div>

        {/* Wallet Balance */}
        <div
          style={{
            background: "#F7F9FB",
            borderRadius: "8px",
            padding: "12px 16px",
            marginBottom: "24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: "13px", color: "#6B7785" }}>
            Sprint Credits Balance:
          </span>
          <span
            style={{ fontSize: "16px", fontWeight: "700", color: "#3A6ED4" }}
          >
            {mySubscription?.credits_remaining ?? 0} Credits
          </span>
        </div>

        {/* Plans Grid */}
        <div style={styles.plansGrid}>
          {sortedPlans.map((plan) => {
            const features =
              typeof plan.features === "string"
                ? JSON.parse(plan.features)
                : plan.features;
            const isHighlighted = plan.tier === "pro_hunter";
            const isCurrentPlan = currentTier === plan.tier;

            return (
              <div
                key={plan.id}
                style={{
                  ...styles.planCard,
                  ...(isHighlighted ? styles.planCardHighlighted : {}),
                  ...(isCurrentPlan
                    ? {
                        border: "2px solid #059669",
                        boxShadow: "0 4px 12px rgba(5, 150, 105, 0.15)",
                      }
                    : {}),
                }}
              >
                {isCurrentPlan &&
                  mySubscription?.cancel_at_period_end &&
                  plan.tier === "pro_hunter" && (
                    <div
                      style={{
                        position: "absolute",
                        top: "12px",
                        left: "12px",
                        right: "12px",
                        background: "#FFF3CD",
                        color: "#856404",
                        fontSize: "11px",
                        fontWeight: "600",
                        padding: "6px 10px",
                        borderRadius: "6px",
                        textAlign: "center",
                      }}
                    >
                      Cancelled — access until{" "}
                      {formatDate(mySubscription?.expiry_date)}
                    </div>
                  )}
                {isHighlighted && !isCurrentPlan && (
                  <div style={styles.planBadge}>Recommended</div>
                )}
                {isCurrentPlan && !mySubscription?.cancel_at_period_end && (
                  <div
                    style={{
                      position: "absolute",
                      top: "12px",
                      right: "12px",
                      background: "#D1FAE5",
                      color: "#065F46",
                      fontSize: "10px",
                      fontWeight: "700",
                      padding: "4px 10px",
                      borderRadius: "20px",
                    }}
                  >
                    Current
                  </div>
                )}

                <h3 style={styles.planName}>{plan.name}</h3>
                <p style={styles.planDescription}>{plan.description}</p>

                <p style={styles.planPrice}>
                  {isFreePlan(plan)
                    ? "Free"
                    : `${currencySymbol}${getDisplayPrice(plan)}`}
                </p>
                {plan.billing_type === "monthly" && !isFreePlan(plan) && (
                  <p style={styles.planPriceSub}>per month</p>
                )}
                {plan.tier === "sprint_pack" && (
                  <p style={styles.planPriceSub}>
                    one-time purchase • 10 credits
                  </p>
                )}

                <ul style={styles.planFeatures}>
                  <li style={styles.planFeature}>
                    <div style={styles.planFeatureIcon}>
                      <svg
                        width="10"
                        height="10"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          stroke="#059669"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <span>On-Platform Match: Unlimited</span>
                  </li>

                  <li style={styles.planFeature}>
                    <div style={styles.planFeatureIcon}>
                      <svg
                        width="10"
                        height="10"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          stroke="#059669"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <span>
                      Off-Platform:{" "}
                      {features?.off_platform_match?.replace(/_/g, " ") ||
                        "Gated"}
                    </span>
                  </li>

                  <li style={styles.planFeature}>
                    <div style={styles.planFeatureIcon}>
                      <svg
                        width="10"
                        height="10"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          stroke="#059669"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <span>
                      Peer Match:{" "}
                      {features?.peer_match_score?.replace(/_/g, " ") ||
                        "Baseline"}
                    </span>
                  </li>

                  <li
                    style={{
                      ...styles.planFeature,
                      ...(plan.tier === "freemium" ||
                      plan.tier === "sprint_pack"
                        ? styles.planFeatureDisabled
                        : {}),
                    }}
                  >
                    <div style={styles.planFeatureIcon}>
                      <svg
                        width="10"
                        height="10"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          stroke="#059669"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <span>AI Resume Rewrites</span>
                  </li>

                  <li style={styles.planFeature}>
                    <div style={styles.planFeatureIcon}>
                      <svg
                        width="10"
                        height="10"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M20 6L9 17l-5-5"
                          stroke="#059669"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <span>Data Retention: {plan.data_retention_days} days</span>
                  </li>
                </ul>

                <CustomButton
                  additionalClass="p-3"
                  text={
                    isCurrentPlan
                      ? "Current Plan"
                      : isFreePlan(plan)
                        ? "Downgrade to Free"
                        : plan.tier === "sprint_pack"
                          ? `Buy 10 Credits for ${currencySymbol}${getDisplayPrice(plan)}`
                          : `Upgrade to Pro Hunter`
                  }
                  backgroundColor={
                    isCurrentPlan
                      ? "#E8ECF0"
                      : isHighlighted
                        ? "#3A6ED4"
                        : "#fff"
                  }
                  color={
                    isCurrentPlan
                      ? "#8A96A3"
                      : isHighlighted
                        ? "#fff"
                        : "#3A6ED4"
                  }
                  border={
                    isCurrentPlan ? "2px solid #059669" : "2px solid #3A6ED4"
                  }
                  handleClick={() => {
                    if (!isCurrentPlan && !isFreePlan(plan)) {
                      handleSubscribe(plan.id);
                    }
                  }}
                  loading={subscribing}
                  disabled={isCurrentPlan || subscribing}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  /* ─── Main Render ───────────────────────────────────────── */
  return (
    <Layout>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
      `}</style>
      <div className="position-relative d-flex flex-column flex-md-row mt-3">
        {loading || subscribing || !plans ? (
          <div className="d-flex justify-content-center align-items-center flex-grow-1 w-100">
            <SectionLoader />
          </div>
        ) : (
          <div className="main-content ml-md-4 flex-grow-1">
            <Card additionalClass="position-relative py-4 w-100">
              <div style={{ padding: "0 20px" }}>
                {renderPlanComparison()}
                {/* {isFreemium ? renderPlanComparison() : renderActiveDashboard()} */}
              </div>
            </Card>
          </div>
        )}

        {/* Cancel Modal (Pro Hunter only) */}
        {showCancelModal && (
          <div
            style={styles.cancelModal}
            onClick={() => setShowCancelModal(false)}
          >
            <div
              style={styles.cancelModalContent}
              onClick={(e) => e.stopPropagation()}
            >
              <h3 style={styles.cancelModalTitle}>
                Are you sure you want to cancel?
              </h3>
              <div style={styles.cancelModalBody}>
                <p style={{ marginBottom: "12px" }}>
                  We're sorry to see you go. If you cancel:
                </p>
                <ul style={{ paddingLeft: "20px", marginBottom: "12px" }}>
                  <li>
                    You'll retain Pro access until{" "}
                    {formatDate(mySubscription?.expiry_date)}
                  </li>
                  <li>You can resubscribe at any time</li>
                </ul>
                <p style={{ marginBottom: 0 }}>
                  <strong>Special Offer:</strong> Switch to Sprint Pack instead
                  and keep access to essential features at a lower price.
                </p>
              </div>
              <div style={styles.cancelModalActions}>
                <CustomButton
                  additionalClass="p-3"
                  text="Keep Subscription"
                  backgroundColor="#fff"
                  color="#3A6ED4"
                  border="1px solid #3A6ED4"
                  handleClick={() => setShowCancelModal(false)}
                />
                <CustomButton
                  additionalClass="p-3"
                  text={cancelling ? "Processing..." : "Confirm Cancellation"}
                  backgroundColor="#DC2626"
                  color="#fff"
                  handleClick={handleCancel}
                  loading={cancelling}
                />
              </div>
            </div>
          </div>
        )}

        {/* Fund Wallet Modal */}
        {showFundWalletModal && (
          <div
            style={styles.cancelModal}
            onClick={() => setShowFundWalletModal(false)}
          >
            <div
              style={styles.cancelModalContent}
              onClick={(e) => e.stopPropagation()}
            >
              <h3 style={styles.cancelModalTitle}>
                Insufficient Wallet Balance
              </h3>
              <div style={styles.cancelModalBody}>
                <p>
                  You don't have enough balance to subscribe to this plan.
                  Please fund your wallet and try again.
                </p>
              </div>
              <div style={styles.cancelModalActions}>
                <CustomButton
                  additionalClass="p-3"
                  text="Maybe Later"
                  backgroundColor="#fff"
                  color="#6B7785"
                  border="1px solid #E8ECF0"
                  handleClick={() => setShowFundWalletModal(false)}
                />
                <CustomButton
                  additionalClass="p-3"
                  text="Fund Wallet"
                  backgroundColor="#3A6ED4"
                  color="#fff"
                  handleClick={() => {
                    setShowFundWalletModal(false);
                    history.push("/wallet/add");
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default JobSeekerSubscriptions;
